import { Card, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { CardActionArea, CardContent, Stack } from "@mui/material";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";
import { parseISO } from "date-fns";

import { WorkplaceReviewCommentAuthorInfo } from "./CommentAuthorInfo";
import { WorkplaceReviewCommentLikesButton } from "./LikesButton";
import { WorkplaceReviewCommentRepliesAndLikesWrapper } from "./RepliesAndLikesWrapper";

interface WorkplaceReviewCommentCompactCardProps {
  commentId: string;
  commentText: string;
  createdAtIso: string;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  totalLikes: number;
  workerName: string;
  isLiked: boolean;
  profilePictureUrl?: string;
  isLoadingProfilePicture?: boolean;
  workplaceId: string;
  maxLines?: number;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export function WorkplaceReviewCommentCompactCard(props: WorkplaceReviewCommentCompactCardProps) {
  const {
    commentId,
    commentText,
    createdAtIso,
    onLikeChanged,
    totalLikes,
    workerName,
    isLiked,
    profilePictureUrl,
    isLoadingProfilePicture,
    workplaceId,
    maxLines,
    onClick,
  } = props;

  return (
    <Card outlined variant="tertiary">
      <CardActionArea
        sx={{
          height: "100%",
          minHeight: "11rem",
        }}
        onClick={onClick}
      >
        <CardContent
          sx={{
            padding: 7,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Text
            variant="body2"
            sx={{
              marginBottom: 6,
              ...(isDefined(maxLines) && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: maxLines,
                WebkitBoxOrient: "vertical",
              }),
            }}
          >
            {commentText}
          </Text>

          <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
            <WorkplaceReviewCommentAuthorInfo
              workerName={workerName}
              profilePictureUrl={profilePictureUrl}
              isLoadingProfilePicture={isLoadingProfilePicture}
              createdAt={parseISO(createdAtIso)}
            />

            <WorkplaceReviewCommentRepliesAndLikesWrapper>
              <WorkplaceReviewCommentLikesButton
                workplaceId={workplaceId}
                commentId={commentId}
                isLiked={isLiked}
                count={totalLikes}
                onLikeChanged={(comment) => {
                  onLikeChanged(comment);
                }}
              />
            </WorkplaceReviewCommentRepliesAndLikesWrapper>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
